import React from 'react';
import { useDropzone } from 'react-dropzone';
import { ACCEPTED_MIME_TYPES, MAX_FILE_SIZE } from '../utils/fileValidation';

const DocumentsDropzone = ({ onDrop, uploading, disabled, t }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPTED_MIME_TYPES,
    multiple: false,
    maxSize: MAX_FILE_SIZE,
    disabled
  });

  return (
    <div
      {...getRootProps()}
      className={`tw-cursor-pointer tw-rounded-lg tw-border tw-border-dashed tw-p-3 tw-text-center tw-text-xs ${
        isDragActive ? 'tw-border-blue-400 tw-bg-blue-50' : 'tw-border-gray-300 tw-bg-white'
      }`}
    >
      <input {...getInputProps()} />
      <p className="tw-font-medium tw-text-gray-700">
        {uploading
          ? t('customerDocuments.uploading', { defaultValue: 'Subiendo documento...' })
          : t('customerDocuments.dropzone', { defaultValue: 'Arrastra un documento o haz clic para subir.' })}
      </p>
      <p className="tw-mt-1 tw-text-gray-500">
        {t('customerDocuments.allowedTypes', {
          defaultValue: 'PDF, DOC, DOCX, XLS, XLSX, PNG, JPG - hasta 25MB'
        })}
      </p>
    </div>
  );
};

export default DocumentsDropzone;
